module.exports = __webpack_public_path__ + "media/images/cover-image-146d5331b010291e5e98d9c56ffad22e.jpg";